import { useGetMessagesSetsPaginatedQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { messagesSetsColumns, type MessagesSetRow } from '../constants/messagesSetsColumns';

export const MessagesSetsList = () => {
    const {
        loading: messagesSetLoading,
        data: messagesSetData,
        error: messagesSetError,
        refetch,
        fetchMore,
    } = useGetMessagesSetsPaginatedQuery({
        variables: { offset: 0, limit: 30 },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    if (messagesSetError) {
        throw new Error('Une erreur est survenue lors de la récupération des messages');
    }

    const hasMore = messagesSetData?.messagesSetsPaginated.hasMore ?? false;
    const messagesSets = messagesSetData?.messagesSetsPaginated.messagesSets ?? [];

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<MessagesSetRow>
                columns={messagesSetsColumns}
                data={messagesSets}
                filterMode="server"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/messagesset/${row._id}`}
                hasMore={hasMore}
                isLoading={messagesSetLoading}
                refetch={async (vars) => {
                    await refetch({ ...vars });
                }}
                fetchMore={async (opts) => {
                    await fetchMore({ variables: opts.variables });
                }}
                emptyMessage="Aucun message n'a été trouvé"
            />
        </div>
    );
};
